import React from 'react'
import ResourceSelector from '../UI/ResourceSelector'

/*
Props:
- unselectedLabel: Unselected option display text (default: `All project types`)
- selectedIdCallback(value): callback for option selected
- value: selected value
*/
const ProjectTypeSelector = props => (
  <ResourceSelector
    resourceAPIEndpoint="project-types"
    resourcePluralName="project types"
    nameAttribute="name"
    {...props}
  />
)

export default ProjectTypeSelector



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/ProjectTypeSelector.jsx